import { createSelector } from "@reduxjs/toolkit";
import { cloneDeep, merge, isEqual } from "lodash";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { initialState } from ".";
import { ModalName } from "components/modal/types";
const createNewArrayWithOverridenValues = (originalCashflows, importedCashflows, editedValues) => {
    const rowsForEdit = cloneDeep(originalCashflows ?? []);
    merge(rowsForEdit, importedCashflows, editedValues);
    return rowsForEdit;
};
export const useGetCurrentCashflows = () => {
    const { id } = useParams();
    const modal = useSelector((state) => state.modals[ModalName.AddOrEditModel], isEqual);
    const editedRows = useSelector((state) => state.administration.cashflowForecastingState.modelEditingState.present.cashflowsState, isEqual);
    const modelCashflows = useSelector((state) => state.entities.CashflowCustomModel[modal.isOpen ? modal.content.id : id]?.cashflows, isEqual);
    const editedModelCashflows = useSelector((state) => state.administration.cashflowForecastingState.modelEditingState.present.cfModelCurrentState?.cashflows, isEqual);
    return useMemo(() => createNewArrayWithOverridenValues(modelCashflows, editedModelCashflows, editedRows), [editedModelCashflows, modelCashflows, editedRows]);
};
const isSaveDisabledSelector = createSelector((state) => state.administration.cashflowForecastingState.modelEditingState.present, (currentState) => currentState.bypassUnsavedChangesPrompt ||
    currentState.isNameInvalid ||
    (Object.keys(currentState.cfModelCurrentState)?.length === Object.keys(initialState?.cfModelCurrentState)?.length && currentState.cashflowsState.length === 0));
export const useIsSaveDisabled = () => useSelector(isSaveDisabledSelector, isEqual);
